import moment from "moment";

type Props = {
    date: string;
    format?: string;
};

const Moment = (props: Props) => {
    const { date, format } = props;
    if (!date) {
        return null;
    }


    if (format) {

        return <> {moment(date).format(format).replace("Z", "")}</>;

    } else if (moment().diff(date, "days") < 1) {

        return <> {moment(date).fromNow()}</>;

    } else
        return <> {moment(date).format("h:mm A, MMM DD, YYYY").replace("Z", "")}</>;

};

export default Moment;
